import React, { Component } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import http from "../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../Routes";
import Modal from 'react-awesome-modal';
import {
    Container,
    Row,
    Col,
    Input,
    Button,
    FormGroup,
    Label,
    Form
} from "reactstrap";
@(connect((state) => {
    return { };
}) as any)
export default class VerifyAccount extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        verify:false,
        userMessage : false,
        v_message : '',
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.verifyAccount();
    }

    @autobind
    verifyAccount(){
        const { token } = this.props.match.params;
        http.get(`/users/user/confirm/${token}`)
            .then(response => response.json())
            .then((data) => {
                //console.log('data',data)
                //alert(data.message);
                this.setState({
                    verify: false,
                    updated: false,
                    userMessage : true,
                    v_message:data.message
                });
            });
    }

    @autobind
    openModalVregister() {
        this.setState({
            verify: true,
            userMessage : true,
            updated : false,
        });
    }

    @autobind
    closeModalVregister() {
        this.setState({
            userMessage : false,
            updated : true,
            verify: true,
        });
    }
    
    render() {
        const {verify,v_message} = this.state
        if (verify) {
            return <Redirect to={Route.toUrl("home")} />
        }else{
            return(
                <Modal
                    visible={this.state.userMessage}
                    width="500"
                    effect="fadeInDown"
                    onClickAway={() => this.closeModalVregister()}
                >
                    <Container>
                        <Row className="coll_popup_header">
                            <Col xs={12} className="text-center coll_title">
                                {v_message}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="link_styless_popup">
                                <Button className='userMessage_form_links' onClick={() => this.closeModalVregister()}>Ok</Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal>
            )
        }
        return "test"
    }
}
